import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

export async function EditAppointment(fhirAppointment: any) {
  const appointment = fhirAppointment;
  const url = `${endpoints.EHRPOSTER}/Appointment/${fhirAppointment.id}`;
  const data = appointment;
  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .put(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`Edit Appointment: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("EditAppointment ", error);
      // toast.error(`EditAppointment Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
